import { KirbyPageData, baseQuery } from "."
import { KirbyBlock } from "./blocks"
import { KirbyImageData, imageQuery } from "./image"
import { KirbyQuerySchema } from "./kql"

export interface KirbyStudentPreviewData extends KirbyPageData {
  title: string
  name: string
  year: string
  tags: string[]
  isEmpty: boolean
  hasThumbnail: boolean
  thumbnail: KirbyImageData | null
  programme: KirbyPageData
  studentsCustomNames?: string
}

export interface KirbyStudentPageData extends KirbyStudentPreviewData {
  text: string
  email?: string
  instagram?: string
  website?: string
  archive?: {
    id: string
    url: string
  }[]
  forceLandscape: boolean
  images: KirbyImageData[]
  content: KirbyBlock[]
  // next: KirbyStudentPreviewData | undefined
  // prev: KirbyStudentPreviewData | undefined
}

export const studentPagePreviewQuery: KirbyQuerySchema["select"] = {
  ...baseQuery,
  title: "page.projectitle",
  name: "page.name",
  year: "page.year",
  tags: "page.tags.split(',')",
  hasThumbnail: "page.thumbnail.isNotEmpty",
  thumbnail: {
    query: "page.thumbnail.toFile",
    select: { ...imageQuery, srcset: "file.srcset([480, 768, 1280])" },
  },
  programme: {
    query: "page.programme.toPage",
    select: baseQuery,
  },
}

// const siblingsQuery = `site.find('students').childrenAndDrafts.filterBy('programme', '$=', page.programme.toPage.uuid)`

export const studentPageQuery: KirbyQuerySchema["select"] = {
  ...studentPagePreviewQuery,
  text: "page.textarea.kirbytext",
  email: "page.email",
  instagram: "page.instagram",
  website: "page.website",
  archive: {
    query: "page.archive.toStructure",
  },
  thumbnail: {
    query: "page.thumbnail.toFile",
    select: imageQuery,
  },
  forceLandscape: "page.forceLandscape.toBool",
  images: {
    query: "page.images",
    select: imageQuery,
  },
  content: "page.thecontent.toBlocks()",
}
